import { useDispatch, useSelector } from "react-redux";
import { fetchLocalData } from "../helpers/storage-helper";
import { authActions } from "../store/auth";
import { ezleadzActions } from "../store/ezleadz-store";
import jwt_decode from "jwt-decode";

const useAuth = () => {
  const data = fetchLocalData("vidamaze_user");
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const ezdata = fetchLocalData("vidamaze_ezdata");
  // const isEzModalStatus = useSelector((state) => state.ezleadzStore.isEzModalStatus);
  const ez_page_load = useSelector((state) => state.ezleadzStore.ez_page_load);

  const dispatch = useDispatch();

  const isLogin = () => {
    if (data?.id) {
      const { exp } = jwt_decode(data.token);

      // console.log(exp)
      const expirationTime = exp * 1000 - 60000;
      if (Date.now() >= expirationTime) {
        localStorage.clear();
        // history.push("/login");
        return false;
      } else {
        if (!isAuthenticated) {
          dispatch(
            authActions.login({
              token: data.token,
              roles: data.roles,
              first_name: data.first_name,
              last_name: data.last_name,
              access: data.access,
              email: data.email,
            })
          );
        }

        if(!ez_page_load  && ezdata?.sid){
          dispatch(ezleadzActions.setEzModalStatus({ status: true }));
          dispatch(ezleadzActions.setEzData({
            sid : ezdata?.sid,
            user_id : ezdata?.uid,
            directory_id : ezdata?.directory_id
          }))
        }
        return true;
        // console.log(isAuthenticated, "akash");
      }
    } else {
      return false;
    }
  };

  return { isLogin };
};

export default useAuth;
